import type { RouteRecordRaw } from 'vue-router';

import { BasicLayout } from '#/layouts';

const routes: RouteRecordRaw[] = [
  {
    component: BasicLayout,
    meta: {
      icon: 'mdi:archive-check-outline',
      order: 4,
      title: '库存订单',
      keepAlive: true,
      hideInMenu: true,
    },
    name: 'InventoryOrderBase',
    path: '/inventory-order',
    redirect: '/inbound-order/inventory',
    children: [
      {
        name: 'InventoryOrderLegacy',
        path: 'index',
        redirect: '/inbound-order/inventory',
      },
    ],
  },
];

export default routes;
